export default {
  body: {
    overflow: 'hidden',
    width: '100vw',
    height: '100vh',
  },
}
